import axios from 'axios';
import { Loading, Message } from 'element-ui'

const service = axios.create({
    // process.env.NODE_ENV === 'development' 来判断是否开发环境
    // easy-mock服务挂了，暂时不使用了
    // baseURL: 'http://192.168.1.112:8600',
    timeout: 5000
});

let loadinginstace
service.interceptors.request.use(
    config => {
        config.headers={
            'content-type':'application/json; charset=utf-8'
        }
        loadinginstace = Loading.service({ fullscreen: true })
        return config;
    },
    error => {
        console.log(error);
        return Promise.reject();
    }
);

service.interceptors.response.use(
    response => {
        loadinginstace.close();
        if (response.status === 200) {
            return response.data;
        } else {
            Promise.reject();
        }
    },
    error => {
        loadinginstace.close();
        console.log(error);
        return Promise.reject();
    }
);

export default service;


// WEBPACK FOOTER //
// ./src/utils/request2.js